module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "titlepage"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _vm._v("Diabetes Cooking "), _c('span', {
    staticClass: "orange"
  }, [_c('b', [_vm._v("101")])])]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_c('span', [_c('b', [_c('span', {
    staticClass: "small"
  }, [_vm._v("MASTER DIABETES COOKING WITH"), _c('br'), _vm._v("101 GREAT RECIPES")])])])]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_c('span', [_c('b', [_c('span', {
    staticClass: "sm"
  }, [_vm._v("EDITED BY")]), _vm._v(" Perrin Davis")])])]), _vm._v(" "), _c('p', {
    staticClass: "editor"
  }, [_c('span', [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/edu.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "editor1"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_vm._v("AN")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("GATE IMPRINT")])])]), _vm._v(" "), _c('p', {
    staticClass: "editor1x"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_vm._v("CHICAGO")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60fae8e5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/titlepage.vue
// module id = 66
// module chunks = 0